import React, { useState } from 'react';
import { X, ArrowLeft, ArrowRight } from 'lucide-react';

const WorkGallery = ({ images, title = "Our Recent Work" }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openLightbox = (index) => {
    setSelectedIndex(index);
  };

  const closeLightbox = () => {
    setSelectedIndex(null);
  };

  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div>
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-dark-navy mb-8 text-center">
        {title}
      </h2>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {images.map((image, index) => (
          <div
            key={index}
            className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 aspect-square"
            onClick={() => openLightbox(index)}
          >
            <img
              src={image}
              alt={`Work ${index + 1}`}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-bmw-blue/0 group-hover:bg-bmw-blue/20 transition-colors duration-300"></div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-bmw-blue transition p-2"
          >
            <X size={32} />
          </button>

          <button
            onClick={prevImage}
            className="absolute left-4 text-white hover:text-bmw-blue transition p-2"
          >
            <ArrowLeft size={32} />
          </button>

          <button
            onClick={nextImage}
            className="absolute right-4 text-white hover:text-bmw-blue transition p-2"
          >
            <ArrowRight size={32} />
          </button>

          <div className="max-w-6xl w-full">
            <div className="relative bg-dark-navy rounded-lg overflow-hidden">
              <img
                src={images[selectedIndex]}
                alt={`Work ${selectedIndex + 1}`}
                className="w-full max-h-[80vh] object-contain"
              />
            </div>

            <p className="text-white text-center mt-4 text-sm">
              {selectedIndex + 1} / {images.length}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkGallery;
